import {Component, OnInit, ViewChild} from '@angular/core';
import {PedidoLoja} from "../objeto/PedidoLoja";
import {NgForm} from "@angular/forms";
import {ClienteService} from "../services/cliente.service";
import {CarrinhoService} from "../services/carrinho.service";
import {Router} from "@angular/router";
import {Location} from "@angular/common";
import {Entrega} from "../objeto/Entrega";
import {ITela} from "../objeto/ITela";
import {DominiosService} from "../services/dominios.service";
import {ConstantsService} from "../services/ConstantsService";
import {FormaDeEntrega} from "../objeto/FormaDeEntrega";

@Component({
  selector: 'app-entrega',
  templateUrl: './entrega.component.html',
  styleUrls: ['./entrega.component.scss']
})
export class EntregaComponent implements OnInit, ITela {
  @ViewChild('frm')  frm: NgForm;
  pedido: PedidoLoja;
  entrega: Entrega =  new Entrega();
  empresa: any = {};
  msgErro: any = '';
  nomePagina: string;
  formasDeEntrega: any = [];
  agendarEntrega: boolean;
  agendouEntrega: boolean;
  apenasAgendamento: any;
  taxaAntiga: number;
  escolherTipo = false;
  possuiLocalizacao = false;
  entregaPorZona = false;
  enderecoAntigo: any = null;
  formaDelivery: any = null;
  erroLocalizacao = false;
  msgErroLocalizacao = '';
  tema: string;
  constructor(private clienteService: ClienteService, private carrinhoService: CarrinhoService,
              private router: Router, private location: Location, private constantsService: ConstantsService,
              private dominiosService: DominiosService) {
    this.nomePagina = dominiosService.obtenhaRaizCardapio();
    this.entrega = new Entrega();

    if ("geolocation" in navigator) {
      this.possuiLocalizacao = true;
    }
  }

  ngOnInit() {
    this.pedido = this.carrinhoService.obtenhaPedido();
    this.entrega = this.pedido.entrega;
    this.formasDeEntrega = [];
    this.taxaAntiga = this.entrega ? this.entrega.taxaDeEntrega : null
    this.enderecoAntigo = (this.entrega.endereco && (this.entrega.endereco.taxaDeEntrega !== undefined)) ? this.entrega.endereco : null

    if(this.entrega && this.entrega.endereco &&   this.entrega.endereco.taxaDeEntrega === undefined) {
      this.entrega.endereco = this.enderecoAntigo

      if(this.entrega.endereco)
        this.entrega.taxaDeEntrega = this.entrega.endereco.taxaDeEntrega
      else
        this.entrega.taxaDeEntrega = null
//      this.entrega = null
//      this.pedido.entrega = null
    }


    this.constantsService.empresa$.subscribe( (empresa) => {
       if(empresa) {
         this.empresa = empresa;
         if(empresa.tema) this.tema = empresa.tema;

         this.apenasAgendamento = !this.empresa.estaRecebendoPedidos && this.empresa.permiteAgendamento
         if(this.apenasAgendamento) this.agendarEntrega = true
         this.empresa.apenasAgendamento = this.apenasAgendamento

         this.formasDeEntrega = this.obtenhaFormasDeEntregaExibicao(empresa.formasDeEntrega || []);
         this.atualizeContextoPedido();

         this.empresa.formasDeEntrega.forEach(forma => {
           if( forma.ativa && forma.formaDeEntrega.nome === FormaDeEntrega.RECEBER_EM_CASA ) {
             this.formaDelivery = forma;
           }

           if(!this.empresa.apenasAgendamento)
             if( this.pedido.entrega.formaDeEntrega === forma.formaDeEntrega.nome ) {
               this.agendarEntrega = forma.agendamentoObrigatorio;
               this.apenasAgendamento = forma.agendamentoObrigatorio;
             }
         });

         if(this.pedido.dataEntrega) {
           this.agendouEntrega = true
           this.agendarEntrega = true
         }
       }
    });

  }

  async onSubmit() {
    if( !this.frm.valid ) {
      return;
    }

    if(!this.agendarEntrega) {
      this.pedido.dataEntrega = null;
      this.pedido.horarioEntrega = null;
    }

    if(this.pedido.temValorMinimo(this.entrega.formaDeEntrega, this.formasDeEntrega)){
      if(!this.pedido.ultrapassouValorMaximo(this.entrega.formaDeEntrega, this.formasDeEntrega)){
        this.pedido.entrega = this.entrega;
        if(this.taxaAntiga && this.taxaAntiga !== this.pedido.entrega.taxaDeEntrega){ //editou valor
          this.pedido.setNovoPagamento()
        }

        this.pedido.calculeTotal();
        this.carrinhoService.salvePedido(this.pedido);

        let codigopromo = this.pedido.cupom ? this.pedido.cupom.codigo : null;

        if(codigopromo)
          await     this.carrinhoService.atualizeValorDesconto(codigopromo, this.empresa);

        if( this.entrega.ehDelivery() && !this.entrega.foiPreenchida() ) {
          this.router.navigate(['/' + this.nomePagina + '/criar-endereco'], {queryParamsHandling: 'merge'});
        }
        else {
          this.router.navigate(['/' + this.nomePagina + '/carrinho'], {queryParamsHandling: 'merge'});
          //this.location.back();
        }
      } else {
        this.exibaErroValorMaximo()
      }

    } else {
      this.exibaErroValorMinimo();
    }
  }

  exibaErroValorMinimo(){
    let valorMinimo = this.pedido.obtenhaValorMinimoParaEntrega(this.entrega.formaDeEntrega, this.formasDeEntrega);

    valorMinimo = ' R$' + valorMinimo.toFixed('2').replace('.', ',');

    if(this.entrega.ehRetirada()){
      this.msgErro = 'Para fazer retiradas , o valor mínimo do pedido é de ' + valorMinimo
    } else {
      this.msgErro = 'Para receber em casa,  o valor mínimo do pedido é de ' + valorMinimo
    }
  }

  exibaErroValorMaximo(){
    let valorMaximo = this.pedido.obtenhaValorMaximoParaEntrega(this.entrega.formaDeEntrega, this.formasDeEntrega)

    valorMaximo = ' R$' + valorMaximo.toFixed('2').replace('.', ',');

    if(this.entrega.ehRetirada()){
      this.msgErro = 'Para fazer retiradas , o valor máximo do pedido é de ' + valorMaximo
    } else {
      this.msgErro = 'Para receber em casa,  o valor máximo do pedido é de ' + valorMaximo
    }
  }

  obtenhaFormaDoPedido() {
    for (let i = 0; i < this.empresa.formasDeEntrega.length; i++) {
      const formaDeEntrega = this.empresa.formasDeEntrega[i];

      if (formaDeEntrega.nome === FormaDeEntrega.RECEBER_EM_CASA)
        return formaDeEntrega;
    }

    return {};
  }

  alterarEndereco() {
    /*
    if( !this.frm.valid ) {
      return;
    }*/
    if(!this.prepareParaInformarEndereco()) return;

    const formaReceberEmCasa = this.obtenhaFormaDoPedido();
    const entregaPorZona = formaReceberEmCasa && formaReceberEmCasa.tipoDeCobranca === 'zona';
    const naoPermiteGps = !formaReceberEmCasa || !formaReceberEmCasa.permiteUsarGps;

    if (entregaPorZona || naoPermiteGps) {
      this.router.navigate(['/' + this.nomePagina + '/criar-endereco'], {queryParamsHandling: 'merge'});
    } else {
      this.escolherTipo = true;
    }
  }

  private prepareParaInformarEndereco() {
    if(this.pedido.temValorMinimoDaFormaEscolhida(this.formasDeEntrega)){
      if(!this.pedido.ultrapassouValorMaximoDaFormaEscolhida(this.formasDeEntrega)){
        this.pedido.entrega = this.entrega;
        this.carrinhoService.salvePedido(this.pedido);
        return true;
      } else {
        this.exibaErroValorMaximo();
      }
    } else {
      this.exibaErroValorMinimo();
    }

    return false;
  }

  informarEndereco() {
    if(!this.prepareParaInformarEndereco()) return;

    this.router.navigate(['/' + this.nomePagina + '/criar-endereco'], {queryParamsHandling: 'merge'});
  }

  deveExibirTopo() {
    return false;
  }

  deveExibirMenu(){
    return false;
  }

  onAntesAlterarFormaEntrega(event: Event, formaEntrega: any){
    if(formaEntrega.indisponivel && !this.apenasAgendamento) {
      event.preventDefault(); // cancela seleção do radio
      event.stopPropagation();
      return;
    }
  }
  alterouFormaDeEntrega(formaEntrega: any) {
    delete this.msgErro;
    if( this.entrega.ehRetirada() ) {
      this.entrega.taxaDeEntrega = 0;
    } else if( this.entrega.endereco ) {
      this.entrega.taxaDeEntrega = this.entrega.endereco.taxaDeEntrega;
    }

    if(!this.empresa.apenasAgendamento) {
      this.agendarEntrega = formaEntrega.agendamentoObrigatorio;
      this.apenasAgendamento = formaEntrega.agendamentoObrigatorio;
    }

    this.pedido.calculeTotal();
    this.carrinhoService.salvePedido(this.pedido);
    setTimeout(() => this.roleAposSelecionarFormaEntrega(), 0);
  }

  private roleAposSelecionarFormaEntrega() {
    const alvo = document.querySelector('.forma-entrega-item.selecionada') as HTMLElement;

    if(!alvo) return;

    alvo.scrollIntoView({behavior: 'smooth', block: 'start'});
  }

  private obtenhaFormasDeEntregaExibicao(formasDeEntregaEmpresa: any[]) {
    let formas = [];

    formasDeEntregaEmpresa.forEach((forma) => {
      if(!forma.ativa) return;

      const formaExibicao = this.crieFormaExibicao(forma);
      formas.push(formaExibicao);

      if(forma.permiteComerNoLocal) {
        formas.push(this.crieFormaComerNoLocal(forma));
      }
    });

    return formas;
  }

  private crieFormaExibicao(forma: any) {
    const formaExibicao = Object.assign({}, forma);
    formaExibicao.nome = forma.formaDeEntrega ? forma.formaDeEntrega.nome : forma.nome;
    formaExibicao.descontoPercentualExibicao = Number(forma.descontoPercentual || 0);
    formaExibicao.possuiDescontoExibicao = !!forma.possuiDesconto && formaExibicao.descontoPercentualExibicao > 0;
    formaExibicao.subtituloDesconto = this.obtenhaSubtituloDesconto(formaExibicao.nome);
    return formaExibicao;
  }

  private crieFormaComerNoLocal(forma: any) {
    const formaComerNoLocal = Object.assign({}, forma);
    formaComerNoLocal.comerNoLocal = true;
    formaComerNoLocal.nome = FormaDeEntrega.COMERNOLOCAL;
    formaComerNoLocal.descontoPercentualExibicao = Number(forma.descontoPercentualComerNoLocal || 0);
    formaComerNoLocal.possuiDescontoExibicao =
      !!forma.possuiDescontoComerNoLocal && formaComerNoLocal.descontoPercentualExibicao > 0;
    formaComerNoLocal.subtituloDesconto = this.obtenhaSubtituloDesconto(FormaDeEntrega.COMERNOLOCAL);
    return formaComerNoLocal;
  }

  private obtenhaSubtituloDesconto(nomeForma: string) {
    if(nomeForma === FormaDeEntrega.COMERNOLOCAL) return 'beneficio para comer no local';
    if(nomeForma === FormaDeEntrega.RECEBER_EM_CASA) return 'beneficio para entrega';
    return 'beneficio para retirada';
  }

  private atualizeContextoPedido() {
    this.pedido.atualizeFormasDeEntregaContexto(this.empresa.formasDeEntrega || []);
    this.pedido.calculeTotal();
    this.carrinhoService.salvePedido(this.pedido);
  }

  possuiDescontoNaForma(formaEntrega: any) {
    return !!formaEntrega.possuiDescontoExibicao;
  }

  obtenhaBadgeDesconto(formaEntrega: any) {
    return `${Number(formaEntrega.descontoPercentualExibicao || 0).toFixed(0)}% OFF`;
  }

  obtenhaDescricaoForma(formaEntrega: any) {
    if(formaEntrega.indisponivel) return null;

    if(this.possuiDescontoNaForma(formaEntrega)) return formaEntrega.subtituloDesconto;

    if(formaEntrega.nome === FormaDeEntrega.COMERNOLOCAL) return 'pedido servido para consumir no local';
    if(formaEntrega.nome === FormaDeEntrega.RECEBER_EM_CASA) return 'receba no endereco escolhido';
    return 'retire no balcao com mais autonomia';
  }

  pegueLocalizacao() {
    this.msgErroLocalizacao = '';
    this.erroLocalizacao = false;

    if(!navigator.geolocation) {
      this.exibaErroLocalizacao('Seu navegador não permite usar localização. Digite o endereço manualmente.');
      return;
    }

    navigator.geolocation.getCurrentPosition((posicao) => {
      const latlng = {
        lat: posicao.coords.latitude,
        lng: posicao.coords.longitude,
      };

      this.router.navigate(['/' + this.nomePagina + '/criar-endereco'], {
        queryParams: {
          endereco: 1,
          gps: 1,
          lat: latlng.lat,
          lng: latlng.lng
        }
      });
    }, (erro) => {
      this.exibaErroLocalizacao(this.obtenhaMensagemErroLocalizacao(erro));
    }, {enableHighAccuracy: true});
  }

  private obtenhaMensagemErroLocalizacao(erro: any) {
    if(erro && erro.code === 1)
      return 'Localização bloqueada no navegador. Libere a permissão ou digite o endereço manualmente.';

    if(erro && erro.code === 2)
      return 'Não conseguimos encontrar sua localização agora. Digite o endereço manualmente ou tente novamente.';

    if(erro && erro.code === 3)
      return 'A localização demorou para responder. Digite o endereço manualmente ou tente novamente.';

    return 'Não conseguimos pegar sua localização. Digite o endereço manualmente ou tente novamente.';
  }

  private exibaErroLocalizacao(mensagem: string) {
    this.msgErroLocalizacao = mensagem;
    this.erroLocalizacao = true;
    setTimeout(() => this.roleAteErroLocalizacao(), 0);
  }

  private roleAteErroLocalizacao() {
    const erroLocalizacao = document.querySelector('.localizacao-erro') as HTMLElement;
    if(!erroLocalizacao) return;

    erroLocalizacao.scrollIntoView({behavior: 'smooth', block: 'center'});
  }

  deveTerBordas() {
    return true;
  }

  deveExibirBannerTema() {
    return false;
  }
}
